<template>
    <div class="p-pt-1 p-ai-center p-grid p-jc-center">
        <div
                class=" p-col  "
        >
            <label>בחר כיתה</label>
            <div class="p-inputgroup">
                <Button
                        v-if="gradeOptionsFiltered && gradeOptionsFiltered.length > 1"
                        v-tooltip.top="'הכיתה הקודמת'"
                        @click="navigateGrades(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי כיתה"
                        emptyFilterMessage=" לא נמצא שם כיתה תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="selectedGrade"
                        :options="gradeOptionsFiltered"
                        placeholder="בחר כיתה"
                        data-key="id"
                        @input="updateGrade"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <div v-if="slotProps.option">
                            <span>{{ slotProps.option.hebrewName }}</span>
                        </div>
                    </template>
                </Dropdown>

                <Button
                        v-if="gradeOptionsFiltered && gradeOptionsFiltered.length > 1"
                        v-tooltip.top="'הכיתה הבאה'"
                        @click="navigateGrades(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>

        <div
                class=" p-col  "
        >
            <label>בחר סוג דיווח</label>
            <div class="p-inputgroup">
                <Button
                        v-if="reportTypesFiltered.length > 1"

                        v-tooltip.top="'הסוג הקודם'"
                        @click="navigateType(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי סוג"
                        emptyFilterMessage=" לא נמצא שם נושא תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="selectedReportType"
                        :options="reportTypesFiltered"
                        placeholder="בחר סוג"
                        data-key="value"
                        @change="updateReportType"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>

                <Button
                        v-if="reportTypesFiltered.length > 1"
                        v-tooltip.top="'הסוג הבא'"
                        @click="navigateType(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
        <div
                class=" p-col  "

        >
            <label>בחר נושא</label>
            <div class="p-inputgroup">
                <Button
                        v-if="subjectFilter && subjectFilter.length > 1"
                        :disabled="selectedReportType &&
				 selectedReportType.value ===
		noteType"
                        v-tooltip.top="'הנושא הקודם'"
                        @click="navigateSubject(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        :disabled="selectedReportType &&
				 selectedReportType.value ===
		noteType"

                        style="text-align: center"
                        filterPlaceholder=" חפש לפי נושא"
                        emptyFilterMessage=" לא נמצא שם נושא תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="selectedSubject"
                        :options="subjectFilter"
                        placeholder="בחר נושא"
                        data-key="id"
                        @input="updateSubject"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>

                <Button
                        v-if="subjectFilter && subjectFilter.length > 1"

                        :disabled="selectedReportType &&
				 selectedReportType.value ===noteType"
                        v-tooltip.top="'הנושא הבא'"
                        @click="navigateSubject(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
<!--        <div-->
<!--                class=" p-col  "-->

<!--        >-->
<!--            <label>בחר נושא הגד</label>-->
<!--            <div class="p-inputgroup">-->
<!--                <Button-->
<!--                        v-if="ratedSubjectFilter && ratedSubjectFilter.length > 1 && selectedReportType &&-->
<!--				 selectedReportType.value ===-->
<!--		ratedType"-->

<!--                        v-tooltip.top="'הנושא הקודם'"-->
<!--                        @click="navigateSubject(false)"-->
<!--                        icon="pi  pi-angle-up"-->
<!--                        class="-->
<!--                    button-grade-back-->
<!--                    p-inputgroup-addon-->
<!--                    plus-->
<!--                    p-button-secondary p-inputgroup-addon-->
<!--                  "-->
<!--                ></Button>-->

<!--                <Dropdown-->
<!--                        :disabled="selectedReportType &&-->
<!--				 selectedReportType.value ===-->
<!--		noteType"-->

<!--                        style="text-align: center"-->
<!--                        filterPlaceholder=" חפש לפי נושא"-->
<!--                        emptyFilterMessage=" לא נמצא שם נושא תואם"-->
<!--                        :filter="true"-->
<!--                        class=""-->
<!--                        optionLabel="hebrewName"-->
<!--                        v-model="selectedSubject"-->
<!--                        :options="ratedSubjectFilter"-->
<!--                        placeholder="בחר נושא"-->
<!--                        data-key="id"-->
<!--                        @input="updateSubject"-->
<!--                >-->
<!--                    <template #value="slotProps">-->
<!--                        <div v-if="slotProps.value">-->
<!--                            <span>{{ slotProps.value.hebrewName }}</span>-->
<!--                        </div>-->
<!--                        <span v-else>-->
<!--                      {{ slotProps.placeholder }}-->
<!--                    </span>-->
<!--                    </template>-->
<!--                    <template #option="slotProps">-->
<!--                        <span>{{ slotProps.option.hebrewName }}</span>-->
<!--                    </template>-->
<!--                </Dropdown>-->

<!--                <Button-->
<!--                        v-if="subjectFilter && subjectFilter.length > 1"-->

<!--                        :disabled="selectedReportType &&-->
<!--				 selectedReportType.value ===noteType"-->
<!--                        v-tooltip.top="'הנושא הבא'"-->
<!--                        @click="navigateSubject(true)"-->
<!--                        icon="pi  pi-angle-down"-->
<!--                        class="plus p-button-secondary p-inputgroup-addon"-->
<!--                ></Button>-->
<!--            </div>-->
<!--        </div>-->
        <div
                v-if="selectedReportType &&
				 selectedReportType.value === ratedType"
                class=" p-col  "

        >
            <label>בחר הגד</label>
            <div class="p-inputgroup">
                <Button

                        v-tooltip.top="'ההגד הקודם'"
                        @click="navigateRate(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown

                        style="text-align: center"
                        filterPlaceholder=" חפש לפי נושא"
                        emptyFilterMessage=" לא נמצא שם נושא תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="selectedRate"
                        :options="reportRatingsFiltered"
                        placeholder="בחר הגד"
                        data-key="id"
                        @input="updateRate"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>

                <Button

                        v-tooltip.top="'ההגד הבא'"
                        @click="navigateRate(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
        <div
                class=" p-col  "
        >
            <label>בחר תעודה למילוי</label>
            <Dropdown
                    optionLabel="displayName"
                    style="text-align: center; width:100%"
                    v-model="selectedReportName"
                    :options="currentReportRanges"
                    placeholder="בחר תעודה"
                    @input="updateReportName"
            >

            </Dropdown>
        </div>
        <div class="p-col" v-if="oldReportRanges.length > 0">
            <label>בחר תעודה קודמת להשוואה</label>
            <Dropdown
                    style="text-align: center; width:100%"
                    v-model="selectedOldReportName"
                    :options="oldReportRanges"
                    optionLabel="displayName"
                    placeholder="בחר תעודה ישנה להצגה"
                    @input="updateOldReportName"
            >

            </Dropdown>
        </div>

    </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";
import PermissionsEnum from "@/utils/permissionsEnum"
import {getGrade, getTopic} from "@/utils/parseObj";
import {removeDuplicatesObject} from "@/utils/objectsUtil";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const RATED_TYPE = "ratedScores"
const NOTE_TYPE = "reportNote"

const reportTypes = [
    {
        value: BEHAVIORS_TYPE,
        hebrewName: "הליכות",
    },
    {
        value: TOPICS_TYPE,
        hebrewName: "מקצוע"
    },
    {
        value: NOTE_TYPE,
        hebrewName: "הערכת מחנך"
    },
    {
        value: RATED_TYPE,
        hebrewName: "דירוג"
    },
    // {
    //     value: PRESENCES_TYPE,
    //     hebrewName: "נוכחות"
    // },
]
export default {
    name: "SelectBar",
    data() {
        return {
            componentKey: 0,
            selectedRate: null,
            selectedGrade: null,
            selectedSubject: null,
            selectedReportName: null,
            selectedOldReportName: null,
            selectedReportType: null,
            reportTypes: reportTypes,
            noteType: NOTE_TYPE,
            ratedType: RATED_TYPE
        }
    },

    created() {
        const storeSelectedGrade = this.$ls.get('grade_selectedGrade')
        const a = this.gradeOptionsFiltered
        const z = a?.filter(grade => grade.id === storeSelectedGrade.id)

        if (storeSelectedGrade && z) {
            this.selectedGrade = storeSelectedGrade
        } else {
            this.selectedGrade = this.gradeOptionsFiltered?.[0]
        }
        // this.selectedGrade = this.$ls.get('grade_selectedGrade') || this.gradeOptionsFiltered?.[0]
        this.selectedReportType = this.$ls.get('grade_selectedReportType') || this.subjectLessonOptionsFiltered?.[0]
        this.selectedOldReportName = this.$ls.get('pupil_selectedOldReportName') || this.oldReportRanges?.[0]
        this.selectedSubject = this.$ls.get('grade_selectedSubject') || this.subjectTracingFilter?.[0]
        this.selectedReportName = this.$ls.get('grade_selectedReportName') || this.reportRanges[0]
        this.updateGrade()
        this.updateSubject()
        this.updateReportName()
        this.updateRate()
        this.updateOldReportName()
        this.updateReportType()
    },
    methods: {
        updateGrade() {
            this.$emit("updateGrade", this.selectedGrade)
        },
        updateSubject() {
            this.$emit("updateSubject", this.selectedSubject)
            this.selectedRate = this.reportRatingsFiltered?.[0]

            this.updateRate()
        },
        updateRate() {
            this.$emit("updateRate", this.selectedRate)
        },
        updateReportName() {
            this.$emit("updateReportName", this.selectedReportName)
        },
        updateOldReportName() {
            this.$emit("updateOldReportName", this.selectedOldReportName)
        },
        updateReportType() {
            // this.selectedRate = this.reportRatingsFiltered?.[0]

            this.$emit("updateReportType", this.selectedReportType)
        },
        navigateGrades(isAdd) {
            if (this.selectedGrade === null) return this.gradeOptionsFiltered[0]
            const index = this.gradeOptionsFiltered.findIndex(
                (grade) => grade?.id === this.selectedGrade?.id
            );
            this.selectedGrade =
                this.gradeOptionsFiltered[
                ((isAdd ? index + 1 : index - 1) + this.gradeOptions.length) %
                this.gradeOptionsFiltered.length
                    ];
            this.updateGrade()
        },
        navigateSubject(isAdd) {
            if (this.selectedReportType.value === TOPICS_TYPE || this.selectedReportType.value === RATED_TYPE) {
                if (this.selectedSubject === null) return this.subjectLessonOptionsFiltered[0]
                const index = this.subjectLessonOptionsFiltered.findIndex(
                    (lessonSubject) => lessonSubject.id === this.selectedSubject.id
                );
                this.selectedSubject =
                    this.subjectLessonOptionsFiltered[
                    ((isAdd ? index + 1 : index - 1) + this.subjectLessonOptionsFiltered.length) %
                    this.subjectLessonOptionsFiltered.length
                        ];
                this.updateSubject()
            } else if (this.selectedReportType.value === BEHAVIORS_TYPE) {
                if (this.selectedSubject === null) return this.subjectTracingFilter[0]
                const index = this.subjectTracingFilter.findIndex(
                    (trackSubject) => trackSubject.id === this.selectedSubject.id
                );
                this.selectedSubject =
                    this.subjectTracingFilter[
                    ((isAdd ? index + 1 : index - 1) + this.subjectTracingFilter.length) %
                    this.subjectTracingFilter.length
                        ];
                this.updateSubject()
            } else if (this.selectedReportType.value === PRESENCES_TYPE) {
                if (this.selectedSubject === null) return this.presenceFilter[0]
                const index = this.presenceFilter.findIndex(
                    (presenceSubject) => presenceSubject.id === this.selectedSubject.id
                );
                this.selectedSubject =
                    this.presenceFilter[
                    ((isAdd ? index + 1 : index - 1) + this.presenceFilter.length) %
                    this.presenceFilter.length
                        ];
                this.updateSubject()
            }
            // else if (this.selectedReportType.value === RATED_TYPE) {
            //     if (this.selectedSubject === null) return this.reportRatings[0]
            //     const index = this.reportRatings.findIndex(
            //         (r) => r.id === this.selectedSubject.id
            //     );
            //     this.selectedSubject =
            //         this.reportRatings[
            //         ((isAdd ? index + 1 : index - 1) + this.reportRatings.length) %
            //         this.reportRatings.length
            //             ];
            //     this.updateSubject()
            // }
        },
        navigateType(isAdd) {
            if (this.selectedReportType === null) {
                this.selectedReportType = this.reportTypesFiltered[0]
                this.updateReportType()
                return
            }
            const isSameSubject = (type) => type === this.selectedReportType;
            const index = this.reportTypesFiltered.findIndex(isSameSubject);
            this.selectedReportType =
                this.reportTypesFiltered[
                ((isAdd ? index + 1 : index - 1) + this.reportTypesFiltered.length) %
                this.reportTypesFiltered.length
                    ];
            this.updateReportType()
        },
        navigateRate(isAdd) {
            console.log(this.reportRatingsFiltered)
            if (this.selectedRate === null) {
                this.selectedRate = this.reportRatingsFiltered[0]
                return this.reportRatingsFiltered[0]
            }
            const isSameSubject = (type) => type === this.selectedRate;
            const index = this.reportRatingsFiltered.findIndex(isSameSubject);
            this.selectedRate =
                this.reportRatingsFiltered[
                ((isAdd ? index + 1 : index - 1) + this.reportRatingsFiltered.length) %
                this.reportRatingsFiltered.length
                    ];
            this.updateRate()
        }
    },
    watch: {
        // selectedSubject
        selectedGrade(newValue) {
            if (newValue) {
                Vue.ls.set('grade_selectedGrade', newValue)
                Vue.ls.set('menage_selectedGrade', newValue);
                Vue.ls.set('pupil_selectedGrade', newValue);
                if (this.selectedReportType.value === this.reportTypesFiltered[3].value){

                } else {
                    switch (this.permissions?.status) {
                        case PermissionsEnum.PERMIT_GRADE:
                            if (this.selectedGrade?.id !== this.permissions?.grades[0]) {
                                this.selectedReportType = this.reportTypesFiltered?.[0]
                                this.selectedSubject = this.subjectLessonOptionsFiltered?.[0]

                                this.updateReportType()
                                this.updateSubject()
                            }
                            break;
                        // } else {
                        //     console.log("PPP", this.reportTypes[1])
                        //     return [this.reportTypes[1]]
                        // }
                        case PermissionsEnum.PERMIT_PARTIAL:
                            this.selectedReportType = this.reportTypesFiltered?.[0]
                            this.selectedSubject = this.subjectLessonOptionsFiltered?.[0]

                            this.updateReportType()
                            this.updateSubject()
                            break;
                    }
                }

            }
        },
        selectedSubject(newValue) {
            if (newValue) {
                Vue.ls.set('grade_selectedSubject', newValue)
            }
        },
        selectedReportName(newValue) {
            if (newValue) {
                Vue.ls.set('pupil_selectedReportName', newValue);
                Vue.ls.set('menage_selectedReportName', newValue);
                Vue.ls.set('grade_selectedReportName', newValue);
            }
        },
        selectedOldReportName(newValue) {
            if (newValue) {
                Vue.ls.set('grade_selectedOldReportName', newValue);
            }
        },
        selectedReportType(newValue, oldValue) {
            if (newValue) {
                this.$ls.set('grade_selectedReportType', newValue)
                // grade_selectedSubject
                switch (newValue?.value) {
                    case TOPICS_TYPE:
                        if (!Vue.ls.get('grade_selectedSubject') || oldValue?.value !== undefined) {
                            this.selectedSubject = this.subjectLessonOptionsFiltered?.[0]
                        }
                        break;
                    case BEHAVIORS_TYPE:
                        if (!Vue.ls.get('grade_selectedSubject') || oldValue?.value !== undefined) {
                            this.selectedSubject = this.subjectTracingFilter?.[0]
                        }
                        break;
                    case RATED_TYPE:
                        console.log("updateReportType - this.selectedSubject: ", this.ratedSubjectFilter?.[0])
                        this.selectedSubject = this.ratedSubjectFilter?.[0]
                        break;
                    case PRESENCES_TYPE:
                        break;
                    case NOTE_TYPE:
                        this.selectedSubject = null
                        break;
                }
                this.updateSubject()
                this.updateReportType()
            }

        },

    },
    computed: {
        ratedSubjectFilter(){
            const z = this.reportRatings.map(rate => rate.subjectName)
            console.log("z",z)

            const a = new Set(z )
            console.log("a",a)
            const q = Array.from(a)
            return q.map(sub => { return {id: sub, hebrewName: sub}})

        },
        oldReportRanges() {
            return this.reportRanges?.filter(report => report.forOldShow)
        },
        currentReportRanges() {
            return this.reportRanges?.filter(report => !report.forOldShow)
        },
        subjectTracingFilter() {
            return this.subjectTracing?.filter((subject) => subject?.reportActive === true)
        },
        // subjectTopicsFilter() {
        //     return this.subjectLessonOptionsFiltered?.filter((subject) => subject?.reportActive === true)
        // },
        presenceFilter() {
            return this.presenceStatus?.filter((subject) => subject?.reportActive === true)
        },
        gradeOptionsFiltered() {
            if (this.selectedReportType?.value === this.reportTypes[3].value){
                return this.gradeOptions
            } else {
                switch (this.permissions.status) {
                    case PermissionsEnum.PERMIT_ALL:
                        return this.gradeOptions
                    case PermissionsEnum.PERMIT_GRADE:
                        const partialGrades = Object.keys(this.permissions.topicsInGrades).map(g => getGrade(g))
                        return [...partialGrades, getGrade(this.permissions.grades[0])]
                    case PermissionsEnum.PERMIT_PARTIAL:
                        return Object.keys(this.permissions.topicsInGrades).map(g => getGrade(g))
                }
            }
        },
        subjectLessonOptionsFiltered() {
            let subjectLessonOptionsFiltered

            switch (this.permissions.status) {
                case PermissionsEnum.PERMIT_ALL:
                    subjectLessonOptionsFiltered = this.subjectLesson?.filter((subject) => subject?.reportActive === true)
                    break;
                case PermissionsEnum.PERMIT_GRADE:
                    if (this.selectedGrade?.id === this.permissions?.grades[0]) {
                        subjectLessonOptionsFiltered = this.subjectLesson?.filter((subject) => subject?.reportActive === true)
                    } else {
                        const topics = this.permissions.topicsInGrades[this.selectedGrade?.id]
                        const topicsObjects = topics?.map(t => getTopic(t))
                        subjectLessonOptionsFiltered = removeDuplicatesObject(topicsObjects)

                    }
                    break;

                case PermissionsEnum.PERMIT_PARTIAL:
                    const topics = this.permissions.topicsInGrades[this.selectedGrade?.id]
                    const topicsObjects = topics?.map(t => getTopic(t))
                    subjectLessonOptionsFiltered = removeDuplicatesObject(topicsObjects)
                    break;

            }

            console.log("this.selectedReportType.value", this.selectedReportType.value)
            if (this.selectedReportType.value === RATED_TYPE) {
                console.log("yesss")

                const subjectRateFilter = this.ratedSubjectFilter?.filter((subject) => {
                    return this.reportRatings.find(rate => rate.subjectName === subject.id)
                })
                console.log("subjectRateFilter", subjectRateFilter)

                return subjectRateFilter
            } else {
                return subjectLessonOptionsFiltered
            }

        },
        reportRatingsFiltered() {
            console.log("this.selectedSubject?.id", this.selectedSubject?.id)
            const subjectMatch =  this.reportRatings?.filter(r => r.subjectName === this.selectedSubject?.id)

            return subjectMatch.filter(rate => {
                const gradesArr = rate?.grades?.split(',')
                return gradesArr?.includes(this.selectedGrade?.id)
            })
        },
        reportTypesFiltered() {
            let reportTypes = this.reportTypes
            if (!this.reportRatings?.length > 0) {
                reportTypes = reportTypes?.filter(r => r.value !== RATED_TYPE)
            }
            switch (this.permissions.status) {
                case PermissionsEnum.PERMIT_ALL:
                    return reportTypes
                case PermissionsEnum.PERMIT_GRADE:
                    if (this.selectedGrade?.id === this.permissions?.grades[0]) {
                        return reportTypes
                    } else {
                        return [reportTypes[1], reportTypes[3]]
                    }
                case PermissionsEnum.PERMIT_PARTIAL:
                    return [reportTypes[1], reportTypes[3]]

            }
        },
        ...mapState(["reportRanges", "reportRatings", "permissions", "intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",
            "subjectTracing"]),
        subjectFilter() {
            if (this.selectedReportType?.value === TOPICS_TYPE) {
                return this.subjectLessonOptionsFiltered
            } else if (this.selectedReportType?.value === BEHAVIORS_TYPE) {
                return this.subjectTracingFilter
            } else if (this.selectedReportType?.value === PRESENCES_TYPE) {
                return this.presenceFilter
            } else if (this.selectedReportType?.value === RATED_TYPE) {
                return this.ratedSubjectFilter
            }
        },
        userPupils() {
            if (this.user?.role !== "ADMIN") {
                return this.pupils?.filter((p) => p.grade?.id === this.user.grade);
            } else {
                return this.pupils?.filter((p) => p.grade?.id ===
                    this?.selectedGrade?.id);
            }
        }
    }
}
</script>

<style scoped>

</style>
